"use strict";

if (document.querySelector('.header-slider')) {
  var swiperIndex = new Swiper('.header-slider .swiper-container', {
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      dynamicMainBullets: 1,
      renderBullet: function renderBullet(index, className) {
        return '<span class="' + className + '">' + (index < 10 ? '0' : '') + (index + 1) + '</span>';
      },
      clickable: true,
      bulletClass: 'pagination-swiper-slider',
      bulletActiveClass: 'active'
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    updateOnWindowResize: true,
    lazy: {
      loadPrevNext: true
    }
  });
}